import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Flex from '@client/components/flex/Flex';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './contact.scss';

const Contact = ({ inputRef }) => {
  const { t } = useTranslation(['advertiser']);

  const phone = t('advertiser:contact.phone');
  return (
    <section ref={inputRef} className={classNames(styles.contact)}>
      <div
        className={classNames(
          styleHelper.landingPageSectionContent,
          styles.contentContainer
        )}
      >
        <Flex column flexNr={1} className={styles.copyContainer}>
          <h4 className={styleHelper.landingDefaultText}>
            {t('advertiser:contact.label')}
          </h4>
          <h2 className={classNames(styleHelper.landingH3, styleHelper.mgt14)}>
            {t('advertiser:contact.title')}
          </h2>
          <p className={classNames(styleHelper.landingP5, styleHelper.mgt14)}>
            {t('advertiser:contact.description')}
          </p>
          <Flex column className={styleHelper.mgt24}>
            {phone && (
              <p className={styleHelper.landingP5}>
                <a href={`tel: ${phone}`} className={styles.activeLink}>
                  {phone}
                </a>
              </p>
            )}
            <p className={styleHelper.landingP5}>
              <a
                href={`mailto:${t('advertiser:contact.email')}`}
                className={styles.activeLink}
              >
                {t('advertiser:contact.email')}
              </a>
            </p>
          </Flex>
        </Flex>
      </div>
    </section>
  );
};

export default Contact;
